import React, { Suspense, useState, useEffect } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { LinearProgress } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router';
import { isUserAuthenticated } from 'src/utils/general.utils';
import { useDocumentTitle } from 'src/hooks';
import { pageTitle } from 'src/config';
import TopBar from './TopBar';
import NavBar from './NavBar';

const useStyles = makeStyles(theme => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0, // IE11 fix
    },
  },
  content: {
    paddingTop: 64,
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256,
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56,
    },
  },
}));

function Dashboard({ route }) {
  const classes = useStyles();
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (!isUserAuthenticated()) {
      history.push('/auth/login');
    }
    // eslint-disable-next-line
  }, []);

  const [currentRoute, setCurrentRoute] = useDocumentTitle(pageTitle);

  useEffect(() => {
    if (currentRoute !== location.pathname) {
      setCurrentRoute(location.pathname);
    }
    // eslint-disable-next-line
  }, [location]);

  return (
    <>
      <TopBar onOpenNavBarMobile={() => setOpenNavBarMobile(true)} />
      <NavBar onMobileClose={() => setOpenNavBarMobile(false)} openMobile={openNavBarMobile} />
      <div className={classes.container}>
        <div className={classes.content}>
          <Suspense fallback={<LinearProgress />}>{renderRoutes(route.routes)}</Suspense>
        </div>
      </div>
    </>
  );
}

Dashboard.propTypes = {
  route: PropTypes.object,
};

export default Dashboard;
